const CheckboxField = ({ checked, label, onChange, compact = false }) => (
  <label className="flex items-center gap-3 cursor-pointer group">
    <div className="relative flex items-center justify-center">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className={`peer appearance-none border-2 border-blue-200 checked:bg-blue-500 checked:border-blue-500 transition-all duration-200 ${
          compact ? "size-4 rounded" : "size-5 rounded-md"
        }`}
      />
      <svg
        className={`absolute text-white opacity-0 peer-checked:opacity-100 transition-opacity duration-200 pointer-events-none ${
          compact ? "size-2.5" : "size-3"
        }`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
    <span
      className={
        compact
          ? "text-[14px] text-gray-700 group-hover:text-blue-600 transition-colors font-sf-medium"
          : "font-sf-medium text-gray-700 group-hover:text-blue-600 transition-colors"
      }
    >
      {label}
    </span>
  </label>
);

const AdditionalInfoFields = ({
  contentRequire,
  error = "",
  isLookup,
  isOriginal,
  isRequire,
  onContentRequireChange,
  onOriginalChange,
  onRequireChange,
  onLookupChange,
  compact = false,
}) => (
  <div
    className={
      compact
        ? "mt-4 p-4 bg-blue-50/50 rounded-xl border border-blue-100 space-y-4"
        : "mt-8 space-y-4 bg-blue-50/50 p-6 rounded-xl border border-blue-100"
    }
  >
    <h4 className="font-sf-semibold text-[#0457C2] uppercase text-sm tracking-wide">
      Thông tin bổ sung
    </h4>

    <div className={`flex flex-col ${compact ? "gap-3" : "gap-4"}`}>
      <CheckboxField
        checked={isLookup}
        compact={compact}
        label="Có yêu cầu Tra cứu"
        onChange={onLookupChange}
      />

      <div className="space-y-3">
        <CheckboxField
          checked={isRequire}
          compact={compact}
          label="Có yêu cầu khác"
          onChange={onRequireChange}
        />

        <div
          className={`motion-safe:animate-[fadeIn_200ms_ease-out] ${
            compact ? "ml-7" : "ml-8"
          }`}
        >
          <textarea
            aria-invalid={Boolean(error)}
            aria-describedby={error ? "additional-info-require-error" : undefined}
            value={contentRequire}
            onChange={(event) => {
              if (!isRequire) onRequireChange(true);
              onContentRequireChange(event.target.value);
            }}
            onFocus={() => {
              if (!isRequire) onRequireChange(true);
            }}
            onMouseDown={() => {
              if (!isRequire) onRequireChange(true);
            }}
            placeholder="Nhập nội dung yêu cầu khác..."
            className={`w-full border rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none min-h-[100px] text-sm transition-all cursor-text ${
              compact ? "p-3" : "p-4"
            } ${
              error
                ? "bg-white border-red-400 text-gray-700 placeholder:text-gray-400 focus:border-red-500 focus:ring-red-500/20"
                :
              !isRequire
                ? "bg-white border-gray-200 text-gray-500 placeholder:text-gray-400"
                : "bg-white border-blue-100 text-gray-700 placeholder:text-gray-400"
            }`}
          />
          {error && (
            <p
              id="additional-info-require-error"
              className="mt-2 text-sm font-sf-medium text-red-600"
            >
              {error}
            </p>
          )}
        </div>
      </div>

      <CheckboxField
        checked={isOriginal}
        compact={compact}
        label="Hồ sơ gốc tài sản trí tuệ"
        onChange={onOriginalChange}
      />
    </div>
  </div>
);

export default AdditionalInfoFields;
